/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Col_ToolInputs */

const en_hub_col_tool = /** @type {(inputs: Hub_Col_ToolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool`)
};

const id_hub_col_tool = /** @type {(inputs: Hub_Col_ToolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alat`)
};

/**
* | output |
* | --- |
* | "Tool" |
*
* @param {Hub_Col_ToolInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_col_tool = /** @type {((inputs?: Hub_Col_ToolInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Col_ToolInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_col_tool(inputs)
	return en_hub_col_tool(inputs)
});